angular.module('bbl.services.api', [])
	.factory('Api.http', ['$http', 'API', '$cacheFactory', '$q', HttpApiServiceFactory])
	.factory('Api', ['Api.http', 'BridgeModel', ApiServiceFactory]);

function HttpApiServiceFactory($http, API, $cacheFactory, $q) {
	var $cache = $cacheFactory('api.$http');

	/**
	 * fetch Fetch a resource from api, and if cache = true, or no cache specified,
	 * Save the response in a cache, and on next call serve the response from cache
	 * @param  {string} url
	 * @param  {Object|null} param
	 * @param  {Object|null} opts
	 * @return {Promise}
	 */
	function fetch(url, params, opts) {
		var _params = angular.extend({format: 'json'}, params),
			_opts = angular.extend({}, opts, {params: _params}),
			cache = angular.extend({cache: true}, params, opts).cache;

		var key = url+':'+$.param(_params);

		// handle cache manually
		delete _opts.cache;
		if(cache && $cache.get(key)) {
			var $cached = $cache.get(key);
			return $q.when(angular.extend({__fromCache: true}, $cached));
		}

		// use own cache, so we can clear it on "no cache" requests
		return $http.get(url, _opts).then(function(response) {

			$cache.put(key, response.data);
			return $cache.get(key);
		});
	}

	/**
	 * fetchNoCache/Api.get  Fetch a resource, but apply no cache
	 * @param  {string} url
	 * @param  {Object|null} param
	 * @param  {Object|null} opts
	 * @return {Promise}
	 */
	function fetchNoCache(url, params, opts) {
		return fetch(url, params, angular.extend({}, opts, {cache: false}));
	}

	function fetchOne(url, id, params, opts) {
		return fetch(url+id+'/', params, opts);
	}

	function save(method, url, data, opts) {
		return $http[method](url, data, opts);
	}

	function update(url, id, data, opts) {
		return save('put', url+id+'/', data, opts);
	}

	function saveOne(url, id, data, opts) {
		return save('post', url+id+'/', data, opts);
	}

	function formSave(url, data, opts) {
		return save('post', url, $.param(data), angular.extend({}, opts, {
			headers: {'Content-Type': 'application/x-www-form-urlencoded'}
		}));
	}

	function __addApi(resource, api) {
		if(__api[resource]) {
			throw new Error('Api `'+resource+'` is already defined!');
		}

		return (__api[resource] = api);
	}

	function clearCache() {
		$cache.removeAll();
	}

	var __api = {
		urls: API,
		get: fetchNoCache,
		fetch: fetch,
		fetchOne: fetchOne,
		saveOne: saveOne,
		update: update,
		save: save.bind(0, 'post'),
		saveForm: formSave,
		clearCache: clearCache,

		extend: __addApi,

		calls: {
			lowerRaisedHand: fetchOne.bind(0, API.call_lower_raised_hand),
			toggleStatus: function(status, bridge, callId) {
        var bridgeId = bridge.id || bridge;
        var prefix = (bridge || {}).service_provider === 'node-cc' ? '/call-control/' : API.call_toggle_status;
				return save('post', prefix + status + '/' + bridgeId + '/' + (callId ? callId + '/' : ''));
			},
			boot: function(bridge, callId) {
        var bridgeId = bridge.id || bridge;
        var prefix = (bridge || {}).service_provider === 'node-cc' ? '/call-control/boot/' : API.call_boot;
				return fetchOne(prefix + bridgeId + '/', callId);
			},
			nudge: function(bridge, id) {
				return saveOne(API.call_nudge+bridge, id);
			},
			lock: fetchOne.bind(0, API.call_lock)
		},

		notifications: {
			list: fetch.bind(0, API.notifications),
			update: update.bind(0, API.notifications)
		}
	};

	return __api;
}

function ApiServiceFactory(Api) {
	return Api;
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/api-service.js
 ** module id = 152
 ** module chunks = 0
 **/